import PropTypes from 'prop-types';
import { BsFire, BsArrowUpRight } from 'react-icons/bs';

import SectionCard from '#globalComponents/Card/SectionCard';

import { useDealsList } from '../../../models/deals/queries';
import { formatEuro } from '../../../utils/formatters';

/**
 * Dashboard widget: top-5 open deals sorted by closing chance desc. Click → open the company.
 */

const HotDealsList = ({ onOpenCompany }) => {
	const { data, isLoading } = useDealsList({
		status: 'open',
		orderBy: 'closingChance',
		orderDir: 'desc',
		pageSize: 5,
	});

	const deals = data?.deals ?? [];

	return (
		<SectionCard title="Heißeste Deals" subtitle="Nach Abschlusswahrscheinlichkeit" icon={BsFire}>
			{isLoading && <p className="text-bgBase-800 text-sm">Wird geladen …</p>}

			{!isLoading && deals.length === 0 && <p className="text-sm text-bgBase-800">Noch keine offenen Deals.</p>}

			<div className="space-y-2">
				{deals.map((d) => {
					const probability = d.closingChance !== null ? Math.round(Number(d.closingChance) * 100) : null;
					return (
						<button
							key={d.id}
							onClick={() => d.crmCompanyId && onOpenCompany?.(d.crmCompanyId)}
							className="group w-full text-left rounded-card border border-bgBase-500 hover:border-primary-300 bg-white p-3 transition-colors"
						>
							<div className="flex items-start justify-between gap-3">
								<div className="flex-1 min-w-0">
									<p className="text-sm font-semibold text-text truncate">{d.title}</p>
									<p className="text-xs text-bgBase-800 truncate mt-0.5">{d.companyNameSnapshot}</p>
									<div className="flex items-center gap-3 mt-1.5">
										<span className="text-xs font-bold text-text">{formatEuro(d.dealValue)}</span>
										{probability !== null && (
											<div className="flex items-center gap-1.5">
												<div className="h-1 w-12 rounded-full bg-bgBase-400 overflow-hidden">
													<div
														className="h-full rounded-full bg-primary-500"
														style={{ width: `${probability}%` }}
													/>
												</div>
												<span className="text-[11px] text-bgBase-800">{probability}%</span>
											</div>
										)}
									</div>
								</div>
								<BsArrowUpRight className="w-3 h-3 text-bgBase-700 group-hover:text-primary-500 flex-shrink-0 transition-colors" />
							</div>
						</button>
					);
				})}
			</div>
		</SectionCard>
	);
};

HotDealsList.propTypes = {
	onOpenCompany: PropTypes.func,
};

export default HotDealsList;
